import { isPartnerEligibleForSimplrCutover } from "@expert/shared-types";

export type SummarySource = "gaia" | "simplr";

export interface SelectSummarySourceArgs {
    /** Resolved value of the `isSimplrSessionSummaryLiveEnabled` feature flag. */
    isSimplrSessionSummaryLiveEnabled: boolean;
    /** Simplr HTTP API base URL, or `undefined` when not configured for this environment. */
    simplrApiUrl: string | undefined;
    /** Partner of the active session, used as a client-side backstop independent of the flag. */
    partner: string | undefined;
    /**
     * Whether this is a production build. In production the backstop restricts the live cutover to
     * the Simplr-eligible partner allowlist; outside production any partner is eligible, so the
     * cutover can be exercised locally without needing an eligible session.
     */
    isProdMode: boolean;
}

/**
 * Chooses which backend serves the live session summary. The summary is fetched from Simplr in place
 * of GAIA only when the `isSimplrSessionSummaryLiveEnabled` flag is on, a Simplr API URL is
 * configured, AND the active partner is eligible for the cutover (see
 * {@link isPartnerEligibleForSimplrCutover}); otherwise it stays on GAIA. Shares its partner
 * eligibility rule with the websocket cutover in `selectWebsocketUrl`.
 */
export function selectSummarySource({
    isSimplrSessionSummaryLiveEnabled,
    simplrApiUrl,
    partner,
    isProdMode,
}: SelectSummarySourceArgs): SummarySource {
    if (isSimplrSessionSummaryLiveEnabled && simplrApiUrl && isPartnerEligibleForSimplrCutover(partner, isProdMode)) {
        return "simplr";
    }
    return "gaia";
}
